import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight, Lock } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
export function CTASection() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.open('https://cuidodemisalud.com/cart/47488134578363:1', '_blank');
  };
  return <section id="cta-section" className="py-24 bg-teal-900 text-white relative overflow-hidden" data-id="element-1">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-2">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-teal-400 rounded-full blur-3xl" data-id="element-3"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-blue-400 rounded-full blur-3xl" data-id="element-4"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-4xl text-center" data-id="element-5">
        <h2 className="text-3xl sm:text-5xl font-bold mb-8" data-id="element-6">
          Recupera tus noches y tu energía
        </h2>
        <p className="text-xl text-teal-100 mb-12 max-w-2xl mx-auto" data-id="element-7">
          Descarga la guía completa hoy y empieza a dormir mejor esta misma
          noche. Sin riesgos, sin pastillas.
        </p>

        <div className="bg-white text-slate-900 p-8 sm:p-12 rounded-3xl shadow-2xl max-w-xl mx-auto transform hover:scale-[1.02] transition-transform duration-300" data-id="element-8">
          <span className="inline-block bg-red-500 text-white text-sm font-bold px-4 py-1.5 rounded-full mb-6" data-id="element-9">
            68% DE DESCUENTO
          </span>
          <div className="mb-8" data-id="element-10">
            <span className="text-slate-500 text-lg line-through mr-4" data-id="element-11">
              $19.99 USD
            </span>
            <span className="text-5xl font-extrabold text-teal-600" data-id="element-12">
              $6.39 USD
            </span>
          </div>

          <Button size="lg" className="w-full text-lg mb-6 shadow-xl shadow-teal-200/50" onClick={handleBuyClick} data-id="element-13">
            Descargar Ahora
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-14" />
          </Button>

          <div className="flex items-center justify-center text-sm text-slate-500" data-id="element-15">
            <Lock className="w-4 h-4 mr-2 text-teal-600" data-id="element-16" />
            Pago 100% Seguro
          </div>
        </div>

        <p className="mt-12 text-teal-200 text-sm" data-id="element-17">
          Acceso inmediato a la descarga digital después de la compra.
        </p>
      </div>
    </section>;
}